import { render, staticRenderFns } from "./ApexChartScatter.vue?vue&type=template&id=8f536eca"
import script from "./ApexChartScatter.vue?vue&type=script&lang=js"
export * from "./ApexChartScatter.vue?vue&type=script&lang=js"
import style0 from "./ApexChartScatter.vue?vue&type=style&index=0&id=8f536eca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports